import app from './app'
import './themes'

app()
